export const activityLogRoutes: AdminRoutes[] = [
  { to: '/admin/activity/talents', content: 'Talent activity' },
  { to: '/admin/activity/companies', content: 'Company activity' },
  { to: '/admin/activity/admin', content: 'Admin activity' },
  { to: '/admin/activity/support', content: 'Support activity' },
];
